var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "banner_height" }, [
        _c(
          "div",
          {
            class: _vm.searchBarFixed == true ? "ondown_banner" : "down_banner",
            attrs: { id: "searchBar" }
          },
          [
            _c("div", { staticClass: "left_close" }, [
              _c("a", {
                staticClass: "down_close",
                on: { click: _vm.goClose }
              }),
              _c("img", {
                staticClass: "down_himg",
                attrs: { src: "/webAssets/images/img/newLogo.png", alt: "" }
              })
            ]),
            _vm.des == ""
              ? _c(
                  "a",
                  { staticClass: "download", on: { click: _vm.goDown } },
                  [_vm._v(_vm._s(_vm.$t("topHeader.buttonText")))]
                )
              : _c(
                  "a",
                  { staticClass: "download", on: { click: _vm.goDownDes } },
                  [_vm._v(_vm._s(_vm.$t("topHeader.buttonText")))]
                ),
            _c("GCDOWN", {
              attrs: { "down-show": _vm.DownShow },
              on: { showDwon: _vm.getshowDonw }
            }),
            _c("GCGUIDE", {
              attrs: {
                "down-show": _vm.guideInfo.weiXin,
                "img-type": _vm.$t("topHeader.shareImg")
              },
              on: { showDwon: _vm.getWechat }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }